import { render, staticRenderFns } from "./moreBoard.vue?vue&type=template&id=14960706&scoped=true"
import script from "./moreBoard.vue?vue&type=script&lang=js"
export * from "./moreBoard.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./moreBoard.vue?vue&type=style&index=1&id=14960706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14960706",
  null
  
)

export default component.exports